module.exports = __webpack_public_path__ + "static/img/校训-字体.491f5ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/校训-字体.png
// module id = lfmv
// module chunks = 1